import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AppContextGuard  {
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    void state;
    const appCode = childRoute.parent?.paramMap.get('appCode') ?? childRoute.paramMap.get('appCode');
    return !!appCode;
  }
}
